import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import {
  LandlordState as EditLandlordState,
  reducer as editLandlordReducer
} from '../screens/landlord/+state/landlords/landlords.reducers';
import {
  PortalsState,
  reducer as portalsReducer
} from './portals/portals.reducers';
import {
  PriosetsState,
  reducer as priosetsReducer
} from './priosets/priosets.reducers';
import {
  ProductsState,
  reducer as productsReducer
} from './products/products.reducers';
import {
  LandlordState,
  reducer as landlordReducer
} from './landlord/landlord.reducers';
import {
  PropertySearcherState,
  reducer as propertySearcherReducer
} from './property-searcher/property-searcher.reducers';

export interface AppState {
  portals: PortalsState;
  prioset: PriosetsState;
  products: ProductsState;
  landlord: LandlordState;
  propertySearcher: PropertySearcherState;
  editLandlord: EditLandlordState;
  AuthModuleState: undefined;
}

export const appReducers: ActionReducerMap<AppState> = {
  portals: portalsReducer,
  prioset: priosetsReducer,
  products: productsReducer,
  landlord: landlordReducer,
  propertySearcher: propertySearcherReducer,
  editLandlord: editLandlordReducer,
  AuthModuleState: null
};

export const getPortalsState = createFeatureSelector<PortalsState>('portals');
export const getPriosetState = createFeatureSelector<PriosetsState>('prioset');
export const getProductsState =
  createFeatureSelector<ProductsState>('products');
export const getLandlordState =
  createFeatureSelector<LandlordState>('landlord');
export const getPropertySearcherState =
  createFeatureSelector<PropertySearcherState>('propertySearcher');
